import Boundary from './Boundary.js';
import BattleZone from './BattleZone.js';
import WaterZone from './WaterZone.js';
import WaterEntryZone from './WaterEntryZone.js';
import LandEntryZone from './LandEntryZone.js';
import DownLedge from './DownLedge.js';
import LeftLedge from './LeftLedge.js';
import RightLedge from './RightLedge.js';
import NPC from './NPC.js';
import TextSource from './TextSource.js';
import WarpZone from './WarpZone.js';
import EventTrigger from './EventTrigger.js';
import TeleportLocation from './TeleportLocation.js';
import LocationIndicatorZone from './LocationIndicatorZone.js';
import VerticalPositionControl from './VerticalPositionControl.js';
import DiagonalMovementControl from './DiagonalMovementControl.js';
import HealingLocation from './HealingLocation.js';
import MartLocation from './MartLocation.js';
import PCLocation from './PCLocation.js';
import OverworldItem from './OverworldItem.js';
import HMTree from './HMTree.js';
import HMRock from './HMRock.js';
import Trainer from './Trainer.js';
import StaticEncounter from './StaticEncounter.js';
import OverworldDecoration from './OverworldDecoration.js';
import OverworldStateMachine from '../state-machine/OverworldStateMachine.js';
import { availableMapSources } from '../OverworldAnimation.js';
import SayHiToMom from './events/SayHiToMom.js';
import BeforeIForget from './events/BeforeIForget.js';
import RivalBattle1 from './events/RivalBattle1.js';
import SelectStarterGrass from './events/SelectStarterGrass.js';
import SelectStarterFire from './events/SelectStarterFire.js';
import SelectStarterWater from './events/SelectStarterWater.js';
import StarterPokemonPokeball from './StarterPokemonPokeball.js';
import DontForgetLunchbox from './events/DontForgetLunchbox.js';
import DontForgetYourStarter from './events/DontForgetYourStarter.js';
import StarterPicked from './events/StarterPicked.js';
import ThankYouForLunchbox from './events/ThankYouForLunchbox.js';
import BaseEvent from './events/BaseEvent.js';
import { imageStore } from '../images.js';

export default class GameMap {
    constructor({
        identifier,
        boundaries = [],
        battleZones = [],
        waterZones = [],
        waterEntryZones = [],
        landEntryZones = [],
        downLedges = [],
        leftLedges = [],
        rightLedges = [],
        npcs = [],
        textSources = [],
        availablePokemon = [],
        warpZones = [],
        locationIndicatorZones = [],
        eventTriggers = [],
        teleportLocations = [],
        verticalPositionControls = [],
        diagonalMovementControls = [],
        healingLocations = [],
        martLocations = [],
        pcLocations = [],
        overworldItems = [],
        hmTrees = [],
        hmRocks = [],
        trainers = [],
        staticEncounters = [],
        starterPokemonPokeballs = [],
        backgroundSrc,
        foregroundSrc,
        backgroundSources = [],
        foregroundSources = [],
        flowers = [],
        needsFlash = false,
        canBike = true,
        events = [],
        fixedTimeOfDay = null,
    }) {
        this.identifier = identifier;
        this.boundaries = boundaries;
        this.battleZones = battleZones;
        this.waterZones = waterZones;
        this.waterEntryZones = waterEntryZones;
        this.landEntryZones = landEntryZones;
        this.downLedges = downLedges;
        this.leftLedges = leftLedges;
        this.rightLedges = rightLedges;
        this.npcs = npcs;
        this.textSources = textSources;
        this.availablePokemon = availablePokemon;
        this.warpZones = warpZones;
        this.eventTriggers = eventTriggers;
        this.teleportLocations = teleportLocations;
        this.locationIndicatorZones = locationIndicatorZones;
        this.verticalPositionControls = verticalPositionControls;
        this.diagonalMovementControls = diagonalMovementControls;
        this.healingLocations = healingLocations;
        this.martLocations = martLocations;
        this.pcLocations = pcLocations;
        this.overworldItems = overworldItems;
        this.hmTrees = hmTrees;
        this.hmRocks = hmRocks;
        this.trainers = trainers;
        this.staticEncounters = staticEncounters;
        this.starterPokemonPokeballs = starterPokemonPokeballs;
        this.backgroundSrc = backgroundSrc;
        this.foregroundSrc = foregroundSrc;
        this.backgroundSources = backgroundSources;
        this.foregroundSources = foregroundSources;
        this.flowers = flowers;
        this.needsFlash = needsFlash;
        this.canBike = canBike;
        this.events = events;
        this.fixedTimeOfDay = fixedTimeOfDay;
        this.warpZones.forEach((wz) => (wz.parentMap = this));
    }

    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            id: this.identifier,
            boundaries: this.boundaries.map((boundary) => boundary.serialize()),
            battleZones: this.battleZones.map((zone) => zone.serialize()),
            waterZones: this.waterZones.map((zone) => zone.serialize()),
            waterEntryZones: this.waterEntryZones.map((zone) => zone.serialize()),
            landEntryZones: this.landEntryZones.map((zone) => zone.serialize()),
            downLedges: this.downLedges.map((ledge) => ledge.serialize()),
            leftLedges: this.leftLedges.map((ledge) => ledge.serialize()),
            rightLedges: this.rightLedges.map((ledge) => ledge.serialize()),
            npcs: this.npcs.map((npc) => npc.serialize()),
            textSources: this.textSources.map((source) => source.serialize()),
            availablePokemon: this.availablePokemon, // Plain data, no serialization needed
            warpZones: this.warpZones.map((zone) => zone.serialize()),
            locationIndicatorZones: this.locationIndicatorZones.map((zone) => zone.serialize()),
            verticalPositionControls: this.verticalPositionControls.map((control) => control.serialize()),
            diagonalMovementControls: this.diagonalMovementControls.map((control) => control.serialize()),
            healingLocations: this.healingLocations.map((location) => location.serialize()),
            martLocations: this.martLocations.map((location) => location.serialize()),
            pcLocations: this.pcLocations.map((location) => location.serialize()),
            overworldItems: this.overworldItems.map((item) => item.serialize()),
            hmTrees: this.hmTrees.map((tree) => tree.serialize()),
            hmRocks: this.hmRocks.map((rock) => rock.serialize()),
            trainers: this.trainers.map((trainer) => trainer.serialize()),
            staticEncounters: this.staticEncounters.map((encounter) => encounter.serialize()),
            backgroundSrc: this.backgroundSrc,
            foregroundSrc: this.foregroundSrc,
            backgroundSources: this.backgroundSources,
            foregroundSources: this.foregroundSources,
            flowers: this.flowers.map((flower) => flower.serialize()),
            needsFlash: this.needsFlash,
            flashWasAttempted: this.flashWasAttempted || false,
            eventTriggers: this.eventTriggers.map((trigger) => trigger.serialize()),
            teleportLocations: this.teleportLocations.map((teleportLocation) => teleportLocation.serialize()),
            events: this.events.map((event) => event.serialize()),
            starterPokemonPokeballs: this.starterPokemonPokeballs.map((starterPokemonPokeball) =>
                starterPokemonPokeball.serialize()
            ),
        };
    }

    static async deserialize(data) {
        // Find map source config by identifier
        const mapSourceConfig = availableMapSources.find((mapSource) => mapSource.identifier === data.id);

        if (!mapSourceConfig) {
            console.warn(
                `Map source config not found for identifier: ${data.id}. Falling back to full deserialization.`
            );
            // Fallback to old behavior if map source not found
            return await this._deserializeLegacy(data);
        }

        // Load fresh map data from map file

        const freshMap = await OverworldStateMachine.loadMap({
            identifier: mapSourceConfig.identifier,
            source: mapSourceConfig.source,
            availablePokemon: mapSourceConfig.availablePokemon || [],
            mapDimensions: mapSourceConfig.mapDimensions,
            backgroundSrc: mapSourceConfig.backgroundSrc,
            foregroundSrc: mapSourceConfig.foregroundSrc,
            backgroundSources: mapSourceConfig.backgroundSources || [],
            foregroundSources: mapSourceConfig.foregroundSources || [],
            mapType: mapSourceConfig.mapType || 'route',
            needsFlash: mapSourceConfig.needsFlash || false,
            canBike: mapSourceConfig.canBike !== undefined ? mapSourceConfig.canBike : true,
        });

        // Helper function to merge deserializable fields by identifier
        const mergeDeserializableField = async (
            freshArray,
            deserializedDataArray,
            deserializeFn,
            useFresh = true
        ) => {
            // Create a Map of deserialized objects keyed by identifier
            const deserializedMap = new Map();

            // Deserialize all items and index by identifier
            const deserializedPromises = deserializedDataArray.map(async (itemData) => {
                const deserializedItem = await deserializeFn(itemData);
                const identifier = deserializedItem.identifier;
                // eslint-disable-next-line eqeqeq
                if (identifier !== null && identifier !== undefined) {
                    deserializedMap.set(identifier, deserializedItem);
                }
                return deserializedItem;
            });
            await Promise.all(deserializedPromises);

            // Merge: use deserialized version if identifier matches, otherwise use fresh version (if useFresh is true)
            // For matching items, preserve state from deserialized data
            // If useFresh is true, also update position from fresh map data
            const mergedArray = [];
            for (const freshItem of freshArray) {
                const identifier = freshItem.identifier;
                // eslint-disable-next-line eqeqeq
                if (identifier !== null && identifier !== undefined && deserializedMap.has(identifier)) {
                    // Use deserialized version to preserve state
                    const deserializedItem = deserializedMap.get(identifier);
                    // Only update position from fresh map data if useFresh is true
                    if (useFresh) {
                        deserializedItem.position = freshItem.position;
                    }
                    mergedArray.push(deserializedItem);
                } else {
                    // Use fresh version (new item added to map) - always include new items
                    mergedArray.push(freshItem);
                }
            }

            return mergedArray;
        };

        // Helper function to merge deserializable fields with dependency control
        const mergeDeserializableFieldWithDependencies = async (
            freshArray,
            deserializedDataArray,
            deserializeFn,
            freshDependencies = [],
            deserializedDependencies = []
        ) => {
            // deserializedDependencies is part of the API but not used in current implementation
            void deserializedDependencies;

            // Step 1: make list of fresh instances
            const freshInstances = freshArray;
            const freshMap = new Map();
            for (const freshItem of freshInstances) {
                const identifier = freshItem.identifier;
                // eslint-disable-next-line eqeqeq
                if (identifier !== null && identifier !== undefined) {
                    freshMap.set(identifier, freshItem);
                }
            }

            // Step 2: make list of deserialized instances
            const deserializedInstances = [];
            const deserializedMap = new Map();
            const deserializedPromises = deserializedDataArray.map(async (itemData) => {
                const deserializedItem = await deserializeFn(itemData);
                const identifier = deserializedItem.identifier;
                // eslint-disable-next-line eqeqeq
                if (identifier !== null && identifier !== undefined) {
                    deserializedMap.set(identifier, deserializedItem);
                }
                deserializedInstances.push(deserializedItem);
                return deserializedItem;
            });
            await Promise.all(deserializedPromises);

            // Step 3: iterate over the deserialized instances. For each deserialized instance, try to find a matching fresh instance. If a match is found, merge the properties from the fresh instance into the deserialized instance only if the property is in the freshDependencies list. If no match is found, add the deserialized instance to the merged array.
            const mergedArray = [];
            const matchedDeserializedIdentifiers = new Set();

            for (const deserializedItem of deserializedInstances) {
                const identifier = deserializedItem.identifier;
                // eslint-disable-next-line eqeqeq
                if (identifier !== null && identifier !== undefined && freshMap.has(identifier)) {
                    // Match found: merge properties from fresh instance
                    const freshItem = freshMap.get(identifier);
                    for (const prop in freshItem) {
                        // Merge if property is in freshDependencies OR if property doesn't exist in deserialized version
                        if (freshDependencies.includes(prop) || !(prop in deserializedItem)) {
                            deserializedItem[prop] = freshItem[prop];
                        }
                    }
                    mergedArray.push(deserializedItem);
                    matchedDeserializedIdentifiers.add(identifier);
                } else {
                    // No match found: add the deserialized instance to the merged array
                    mergedArray.push(deserializedItem);
                }
            }

            // Step 4: Iterate over the fresh instances. Try to find a matching instance in the list of deserialized instances. If there is no match, add the fresh instance to the merged array.
            for (const freshItem of freshInstances) {
                const identifier = freshItem.identifier;
                // eslint-disable-next-line eqeqeq
                if (identifier !== null && identifier !== undefined && !matchedDeserializedIdentifiers.has(identifier)) {
                    // No match found in deserialized instances: add the fresh instance to the merged array
                    mergedArray.push(freshItem);
                }
            }
            return mergedArray;
        };

        // Merge deserializable fields
        const mergedNpcs = await mergeDeserializableField(
            freshMap.npcs,
            data.npcs || [],
            async (npcData) => await NPC.deserialize(npcData),
            false
        );
        const mergedEventTriggers = await mergeDeserializableFieldWithDependencies(
            freshMap.eventTriggers,
            data.eventTriggers || [],
            (triggerData) => EventTrigger.deserialize(triggerData),
            ['type'], // freshDependencies - add properties here that should always come from fresh
            [] // deserializedDependencies - add properties here that should come from deserialized
        );

        const mergedOverworldItems = await mergeDeserializableField(
            freshMap.overworldItems,
            data.overworldItems || [],
            (itemData) => OverworldItem.deserialize(itemData)
        );

        const mergedTrainers = await mergeDeserializableField(
            freshMap.trainers,
            data.trainers || [],
            async (trainerData) => await Trainer.deserialize(trainerData),
            false // useFresh = false: only use trainers from saved data, skip fresh trainers that aren't in saved data
        );

        const mergedStaticEncounters = await mergeDeserializableField(
            freshMap.staticEncounters,
            data.staticEncounters || [],
            (encounterData) => StaticEncounter.deserialize(encounterData)
        );

        const mergedStarterPokemonPokeballs = await mergeDeserializableField(
            freshMap.starterPokemonPokeballs,
            data.starterPokemonPokeballs || [],
            (starterPokemonPokeballData) => StarterPokemonPokeball.deserialize(starterPokemonPokeballData)
        );

        const uniqueEventIdentifiers = [...new Set(mergedEventTriggers.map((et) => et.eventIdentifier))];

        const freshEvents = await Promise.all(
            uniqueEventIdentifiers.map(async (eventIdentifier) => {
                const event = await BaseEvent.loadEvent(eventIdentifier);
                return event;
            })
        );
        const mergedEvents = data.events.map((event) => {
            switch (event.identifier) {
                case 'say_hi_to_mom':
                    return SayHiToMom.deserialize(event);
                case 'before_i_forget':
                    return BeforeIForget.deserialize(event);
                case 'rival_battle_1':
                    return RivalBattle1.deserialize(event);
                case 'select_starter_grass':
                    return SelectStarterGrass.deserialize(event);
                case 'select_starter_fire':
                    return SelectStarterFire.deserialize(event);
                case 'select_starter_water':
                    return SelectStarterWater.deserialize(event);
                case 'dont_forget_lunchbox':
                    return DontForgetLunchbox.deserialize(event);
                case 'dont_forget_your_starter':
                    return DontForgetYourStarter.deserialize(event);
                case 'starter_picked':
                    return StarterPicked.deserialize(event);
                case 'thank_you_for_lunchbox':
                    return ThankYouForLunchbox.deserialize(event);
            }
        });

        // Add any events not present in mergedEvents from freshEvents to mergedEvents
        const mergedEventIdentifiers = new Set(mergedEvents.map((event) => event.identifier));
        for (const freshEvent of freshEvents) {
            if (!mergedEventIdentifiers.has(freshEvent.identifier)) {
                mergedEvents.push(freshEvent);
            }
        }

        // Build GameMap with fresh map data for non-deserializable fields and merged data for deserializable fields
        const gameMap = new GameMap({
            identifier: freshMap.identifier,
            boundaries: freshMap.boundaries,
            battleZones: freshMap.battleZones,
            waterZones: freshMap.waterZones,
            waterEntryZones: freshMap.waterEntryZones,
            landEntryZones: freshMap.landEntryZones,
            downLedges: freshMap.downLedges,
            leftLedges: freshMap.leftLedges,
            rightLedges: freshMap.rightLedges,
            npcs: mergedNpcs,
            textSources: freshMap.textSources,
            availablePokemon: freshMap.availablePokemon,
            warpZones: freshMap.warpZones,
            eventTriggers: mergedEventTriggers,
            teleportLocations: freshMap.teleportLocations,
            locationIndicatorZones: freshMap.locationIndicatorZones,
            verticalPositionControls: freshMap.verticalPositionControls,
            diagonalMovementControls: freshMap.diagonalMovementControls,
            healingLocations: freshMap.healingLocations,
            martLocations: freshMap.martLocations,
            pcLocations: freshMap.pcLocations,
            overworldItems: mergedOverworldItems,
            hmTrees: freshMap.hmTrees,
            hmRocks: freshMap.hmRocks,
            trainers: mergedTrainers,
            staticEncounters: mergedStaticEncounters,
            backgroundSrc: freshMap.backgroundSrc,
            foregroundSrc: freshMap.foregroundSrc,
            backgroundSources: freshMap.backgroundSources,
            foregroundSources: freshMap.foregroundSources,
            flowers: freshMap.flowers,
            needsFlash: freshMap.needsFlash,
            canBike: freshMap.canBike,
            events: mergedEvents,
            fixedTimeOfDay: freshMap.fixedTimeOfDay,
            starterPokemonPokeballs: mergedStarterPokemonPokeballs,
        });

        gameMap.events.forEach((event) => {
            event.map = gameMap;
        });

        // Restore runtime state
        gameMap.flashWasAttempted = data.flashWasAttempted || false;

        return gameMap;
    }

    // Legacy deserialization method for fallback
    static async _deserializeLegacy(data) {
        const gameMap = new GameMap({
            identifier: data.id,
            boundaries: data.boundaries.map((boundaryData) => Boundary.deserialize(boundaryData)),
            battleZones: data.battleZones.map((zoneData) => BattleZone.deserialize(zoneData)),
            waterZones: data.waterZones.map((zoneData) => WaterZone.deserialize(zoneData)),
            waterEntryZones: data.waterEntryZones.map((zoneData) => WaterEntryZone.deserialize(zoneData)),
            landEntryZones: data.landEntryZones.map((zoneData) => LandEntryZone.deserialize(zoneData)),
            downLedges: data.downLedges.map((ledgeData) => DownLedge.deserialize(ledgeData)),
            leftLedges: data.leftLedges.map((ledgeData) => LeftLedge.deserialize(ledgeData)),
            rightLedges: data.rightLedges.map((ledgeData) => RightLedge.deserialize(ledgeData)),
            npcs: await Promise.all(data.npcs.map(async (npcData) => await NPC.deserialize(npcData))),
            textSources: data.textSources.map((sourceData) => TextSource.deserialize(sourceData)),
            availablePokemon: data.availablePokemon,
            warpZones: data.warpZones.map((zoneData) => WarpZone.deserialize(zoneData)),
            eventTriggers: data.eventTriggers.map((triggerData) => EventTrigger.deserialize(triggerData)),
            teleportLocations: data.teleportLocations.map((teleportLocationData) =>
                TeleportLocation.deserialize(teleportLocationData)
            ),
            locationIndicatorZones: data.locationIndicatorZones.map((zoneData) =>
                LocationIndicatorZone.deserialize(zoneData)
            ),
            verticalPositionControls: data.verticalPositionControls.map((controlData) =>
                VerticalPositionControl.deserialize(controlData)
            ),
            diagonalMovementControls: data.diagonalMovementControls.map((controlData) =>
                DiagonalMovementControl.deserialize(controlData)
            ),
            healingLocations: data.healingLocations.map((locationData) =>
                HealingLocation.deserialize(locationData)
            ),
            martLocations: data.martLocations.map((locationData) => MartLocation.deserialize(locationData)),
            pcLocations: data.pcLocations.map((locationData) => PCLocation.deserialize(locationData)),
            overworldItems: data.overworldItems.map((itemData) => OverworldItem.deserialize(itemData)),
            hmTrees: data.hmTrees.map((treeData) => HMTree.deserialize(treeData)),
            hmRocks: data.hmRocks.map((rockData) => HMRock.deserialize(rockData)),
            trainers: await Promise.all(
                data.trainers.map(async (trainerData) => await Trainer.deserialize(trainerData))
            ),
            staticEncounters: (data.staticEncounters || []).map((encounterData) =>
                StaticEncounter.deserialize(encounterData)
            ),
            backgroundSrc: data.backgroundSrc,
            foregroundSrc: data.foregroundSrc,
            backgroundSources: data.backgroundSources,
            foregroundSources: data.foregroundSources,
            flowers: data.flowers.map((flowerData) => OverworldDecoration.deserialize(flowerData)),
            needsFlash: data.needsFlash,
        });

        gameMap.flashWasAttempted = data.flashWasAttempted || false;
        return gameMap;
    }

    getObjectByIdentifier(identifier) {
        const obj =
            this.npcs.find((npc) => npc.identifier === identifier) ||
            this.trainers.find((trainer) => trainer.identifier === identifier) ||
            this.overworldItems.find((item) => item.identifier === identifier) ||
            this.hmTrees.find((tree) => tree.identifier === identifier) ||
            this.hmRocks.find((rock) => rock.identifier === identifier) ||
            this.starterPokemonPokeballs.find(
                (starterPokemonPokeball) => starterPokemonPokeball.identifier === identifier
            ) ||
            this.eventTriggers.find((trigger) => trigger.identifier === identifier);
        if (!obj) {
            console.warn(`Object with identifier ${identifier} not found in map ${this.identifier}`);
            return null;
        }
        return obj;
    }

    getEventTriggersByIdentifier(identifier) {
        return this.eventTriggers.filter((trigger) => trigger.identifier === identifier);
    }

    getNPCByIdentifier(identifier) {
        // implement
        const availableNPCs = [...this.npcs, ...this.trainers].filter((npc) => npc.identifier === identifier);
        // debugger;
        if (availableNPCs.length === 0) {
            console.warn(`NPC for identifier ${identifier} not available in map ${this.identifier}`);
            return null;
        }

        if (availableNPCs.length > 1) {
            console.warn(
                `More than 1 NPC contains identifier ${identifier} in map ${this.identifier}. Defaulting to first.`
            );
        }
        return availableNPCs[0];
    }

    getBattleArenaImages() {
        switch (this.identifier) {
            case 'bramblecrest':
            case 'mistral_heights':
                return {
                    land: {
                        backgroundImage: imageStore.get('img/battle_scenes/grass1/background.png'),
                        playerStageImage: imageStore.get('img/battle_scenes/grass1/player_stage.png'),
                        foeStageImage: imageStore.get('img/battle_scenes/grass1/foe_stage.png'),
                    },
                    water: {
                        backgroundImage: imageStore.get('img/battle_scenes/swamp/background.png'),
                        playerStageImage: imageStore.get('img/battle_scenes/swamp/player_stage.png'),
                        foeStageImage: imageStore.get('img/battle_scenes/swamp/foe_stage.png'),
                    },
                };
            case 'route01':
            case 'route02':
                return {
                    land: {
                        backgroundImage: imageStore.get('img/battle_scenes/grass2/background.png'),
                        playerStageImage: imageStore.get('img/battle_scenes/grass2/player_stage.png'),
                        foeStageImage: imageStore.get('img/battle_scenes/grass2/foe_stage.png'),
                    },
                    water: {
                        backgroundImage: imageStore.get('img/battle_scenes/swamp/background.png'),
                        playerStageImage: imageStore.get('img/battle_scenes/swamp/player_stage.png'),
                        foeStageImage: imageStore.get('img/battle_scenes/swamp/foe_stage.png'),
                    },
                };
            case 'vine_cave':
                return {
                    land: {
                        backgroundImage: imageStore.get('img/battle_scenes/cave/background.png'),
                        playerStageImage: imageStore.get('img/battle_scenes/cave/player_stage.png'),
                        foeStageImage: imageStore.get('img/battle_scenes/cave/foe_stage.png'),
                    },
                    water: {
                        backgroundImage: imageStore.get('img/battle_scenes/swamp/background.png'),
                        playerStageImage: imageStore.get('img/battle_scenes/swamp/player_stage.png'),
                        foeStageImage: imageStore.get('img/battle_scenes/swamp/foe_stage.png'),
                    },
                };
            default:
                return {
                    land: {
                        backgroundImage: imageStore.get('img/battle_scenes/land1/background.png'),
                        playerStageImage: imageStore.get('img/battle_scenes/land1/player_stage.png'),
                        foeStageImage: imageStore.get('img/battle_scenes/land1/foe_stage.png'),
                    },
                    water: {
                        backgroundImage: imageStore.get('img/battle_scenes/water/background.png'),
                        playerStageImage: imageStore.get('img/battle_scenes/water/player_stage.png'),
                        foeStageImage: imageStore.get('img/battle_scenes/water/foe_stage.png'),
                    },
                };
        }
    }
}
